import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { openSidePanel } from '@alfa-bank/newclick-core/window-utils';
import { OpenSidePanelsParams } from '@alfa-bank/newclick-types/open-side-panel-params';
import { createCn } from 'bem-react-classname';

import { Button } from '@alfalab/core-components/button';
import { Gap } from '@alfalab/core-components/gap';

import { useAppSelector } from '#/src/shared/hooks';
import { trackUserEvent } from '#/src/shared/lib/analitycs';
import { ButtonNames, Routes } from '#/src/shared/models';
import { useInitializePasscodeMutation } from '#/src/shared/store/api/passcode-api';
import { selectClientId, selectIsMobile } from '#/src/shared/store/redux/app/selectors';

import { Modals } from '../modals';

import { ButtonInform } from './components/button-inform';

import './alt-login-browser.css';

export const cn = createCn('alt-login-browser');

const AlternativeLoginBrowser = () => {
    const navigate = useNavigate();
    const { search } = useLocation();

    const clientId = useAppSelector(selectClientId);
    const isMobile = useAppSelector(selectIsMobile);

    const [initializePasscode, { isLoading: isInitializing, isSuccess }] =
        useInitializePasscodeMutation();
    const [isButtonLoading, setIsButtonLoading] = useState(false);

    useEffect(() => {
        initializePasscode();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleAlternativeLogin = useCallback(() => {
        if (isInitializing) {
            setIsButtonLoading(true);

            return;
        }

        if (isSuccess) {
            openSidePanel({
                sidePanelId: 'Alt-login',
            } as unknown as OpenSidePanelsParams);
        } else {
            navigate({ pathname: Routes.TEMP_PASSWORD, search });
        }

        setIsButtonLoading(false);

        trackUserEvent('Auth Page', 'Click', 'Click on button Another way to enter', clientId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isInitializing, isSuccess]);

    useEffect(() => {
        if (!isInitializing && isButtonLoading) {
            handleAlternativeLogin();
        }
    }, [isInitializing, isButtonLoading, handleAlternativeLogin]);

    return (
        <React.Fragment>
            <Button
                className={cn('button-wrapper')}
                block={true}
                type='button'
                loading={isButtonLoading}
                onClick={handleAlternativeLogin}
                dataTestId='alternative-button'
            >
                {ButtonNames.alternativeLogin}
            </Button>
            <Gap size={isMobile ? 'xl' : 'm'} direction='vertical' />

            {isMobile ? null : <ButtonInform />}
            <Modals isMobile={isMobile} />
        </React.Fragment>
    );
};

export default AlternativeLoginBrowser;
